import { Component, Input } from '@angular/core';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-shared-info-copy',
  templateUrl: './shared-info-copy.component.html',
  styleUrls: ['./shared-info-copy.component.scss'],
})
export class SharedInfoCopyComponent {
  @Input() label?: string;
  @Input() content?: string;
  @Input() content_class: string = 'sp-color__primary';
  @Input() layout_class: string = 'sp-margin__bottom-x2';
  @Input() is_shrinked_id?: boolean;

  constructor(private utils_service: UtilsService) {}

  onCopyClick(): void {
    this.utils_service.copyClick(this.content);
  }

  getShrinkedID(): string {
    return this.utils_service.getShrinkedID(this.content);
  }
}
